module.exports = __webpack_public_path__ + "img/shortcode_hifi_4.f8419f90.png";